import React, { useRef } from 'react';

const MENU_URL = 'https://nayanskitchen.com/menu';
const PDF_FILE = '/menu.pdf';

const dishes = [
    { name: 'Misal Pav', sub: 'Served with 2 pav', desc: 'Spicy sprouted mot curry topped with farsan and fresh onions.', price: 180 },
    { name: 'Mini Vada Pav', sub: '6 pieces', desc: 'Golden fried mini vadas stuffed with spiced potato filling.', price: 120 },
    { name: 'Kothimbir Vadi', sub: '6 pieces', desc: 'Steamed and lightly crisped coriander cakes infused with authentic spices.', price: 150 },
    { name: 'Sabudana Vada', sub: '2 pieces', desc: 'Crisp golden patties made with sabudana and crushed peanuts.', price: 160 },
    { name: 'Dabeli', sub: '2 pieces', desc: 'Sweet-spicy potato masala layered with coated peanuts, pomegranate and crunchy sev.', price: 150 },
    { name: 'Thecha', sub: 'Per 100 gm', desc: 'Crushed green chillies, garlic and peanuts — bold and fiery.', price: 100 },
];

const sweets = [
    { name: 'Puranpoli', sub: 'Min. order: 5 pieces', desc: 'Soft, golden polis stuffed with rich jaggery & chana dal filling, delicately flavoured with cardamom.', price: 85, unit: '/ piece' },
    { name: 'Ukadiche Modak', sub: 'Min. order: 6 pieces', desc: 'Steamed rice flour dumplings filled with luscious coconut & jaggery mixture.', price: 50, unit: '/ piece' },
    { name: 'Carrot Halwa', sub: 'Per 100 gm · Seasonal Special', desc: 'Slow-cooked fresh carrots simmered in milk, enriched with homemade ghee, kesar and dry fruits.', price: 85 },
    { name: 'Sooji Halwa', sub: '250 gm', desc: 'Roasted sooji blended with milk, fragrant saffron and pure ghee.', price: 160 },
];

export default function MenuCard() {
    const pageRef = useRef();

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = PDF_FILE;
        link.download = 'Nayans_Kitchen_Menu.pdf';
        link.click();
    };

    return (
        <div ref={pageRef} style={{ fontFamily: "'Georgia', serif", background: '#FFFBF0', minHeight: '100vh', color: '#3B1E08' }}>

            {/* Header */}
            <div style={{ background: 'linear-gradient(135deg, #7B3F00, #5C2D00)', padding: '2.5rem 1.5rem 2rem', textAlign: 'center' }}>
                <img src="/logo.png" alt="Logo" style={{ width: 72, height: 72, borderRadius: 16, border: '3px solid rgba(255,255,255,0.3)', marginBottom: 16, objectFit: 'contain', background: 'rgba(255,255,255,0.1)' }} />
                <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff', margin: 0, letterSpacing: 1 }}>Nayan's Kitchen</h1>
                <p style={{ fontSize: '1rem', color: '#F5C97E', margin: '4px 0 0', fontStyle: 'italic' }}>& Delights</p>
                <p style={{ fontSize: '0.85rem', color: '#F5C97E', marginTop: 8, letterSpacing: 2 }}>♥ Taste That Touches the Soul ♥</p>

                {/* Download Button */}
                <button
                    onClick={handleDownload}
                    style={{ marginTop: 20, background: '#F5C97E', color: '#5C2D00', border: 'none', borderRadius: 50, padding: '10px 28px', fontWeight: 'bold', fontSize: '0.95rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}
                >
                    ⬇ Download Menu PDF
                </button>
            </div>

            {/* Brand Story */}
            <div style={{ maxWidth: 680, margin: '0 auto', padding: '2rem 1.5rem 1rem', textAlign: 'center' }}>
                <p style={{ color: '#B45309', fontStyle: 'italic', fontWeight: 'bold', fontSize: '1.15rem', marginBottom: 12 }}>Where Tradition Meets Indulgence</p>
                <p style={{ lineHeight: 1.8, color: '#4B2800', fontSize: '0.97rem', marginBottom: 10 }}>
                    At <strong>Nayan's Kitchen & Delights</strong>, every dish is a celebration of authentic Maharashtrian flavours crafted with purity, patience and passion.
                </p>
                <p style={{ lineHeight: 1.8, color: '#5C3010', fontSize: '0.93rem', marginBottom: 10 }}>
                    Slow-cooked fillings, hand-rolled polis, aromatic homemade ghee, rich Kolhapuri jaggery and freshly ground spices — each ingredient is thoughtfully chosen to deliver unforgettable taste.
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center', marginTop: 16, marginBottom: 8 }}>
                    {['Freshly prepared', 'Premium quality ingredients', 'No artificial flavours', 'Made with love & tradition'].map(tag => (
                        <span key={tag} style={{ background: '#FEF3C7', border: '1px solid #D97706', color: '#92400E', borderRadius: 20, padding: '4px 14px', fontSize: '0.82rem', fontWeight: 600 }}>✦ {tag}</span>
                    ))}
                </div>
            </div>

            <hr style={{ border: 'none', borderTop: '2px solid #F5C97E', margin: '0 1.5rem' }} />

            {/* Menu Section */}
            <div style={{ maxWidth: 680, margin: '0 auto', padding: '1.5rem 1.5rem' }}>

                {/* Maharashtrian Delights */}
                <div style={{ marginBottom: '2rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                        <span style={{ fontSize: '1.3rem' }}>🍽️</span>
                        <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#7B3F00', margin: 0 }}>Maharashtrian Delights</h2>
                        <div style={{ flex: 1, height: 1, background: '#D97706' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {dishes.map(item => (
                            <div key={item.name} style={{ background: '#fff', borderRadius: 12, padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: '0 1px 6px rgba(180,83,9,0.1)', border: '1px solid #FDE68A' }}>
                                <div style={{ flex: 1 }}>
                                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '1rem', color: '#3B1E08' }}>{item.name}</p>
                                    <p style={{ margin: '2px 0 4px', fontSize: '0.78rem', color: '#B45309', fontStyle: 'italic' }}>{item.sub}</p>
                                    <p style={{ margin: 0, fontSize: '0.85rem', color: '#6B3C1A', lineHeight: 1.5 }}>{item.desc}</p>
                                </div>
                                <div style={{ minWidth: 64, textAlign: 'right', paddingLeft: 12 }}>
                                    <span style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#7B3F00' }}>₹{item.price}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Signature Sweets */}
                <div style={{ marginBottom: '2rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                        <span style={{ fontSize: '1.3rem' }}>🍮</span>
                        <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#7B3F00', margin: 0 }}>Signature Sweets</h2>
                        <div style={{ flex: 1, height: 1, background: '#D97706' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {sweets.map(item => (
                            <div key={item.name} style={{ background: '#fff', borderRadius: 12, padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: '0 1px 6px rgba(180,83,9,0.1)', border: '1px solid #FDE68A' }}>
                                <div style={{ flex: 1 }}>
                                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '1rem', color: '#3B1E08' }}>{item.name}</p>
                                    <p style={{ margin: '2px 0 4px', fontSize: '0.78rem', color: '#B45309', fontStyle: 'italic' }}>{item.sub}</p>
                                    <p style={{ margin: 0, fontSize: '0.85rem', color: '#6B3C1A', lineHeight: 1.5 }}>{item.desc}</p>
                                </div>
                                <div style={{ minWidth: 64, textAlign: 'right', paddingLeft: 12 }}>
                                    <span style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#7B3F00' }}>₹{item.price}</span>
                                    {item.unit && <p style={{ margin: 0, fontSize: '0.72rem', color: '#92400E' }}>{item.unit}</p>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Pickup & Delivery */}
                <div style={{ background: '#FEF9EE', border: '2px solid #F5C97E', borderRadius: 16, padding: '1.5rem', marginBottom: '1.5rem' }}>
                    <h2 style={{ textAlign: 'center', fontSize: '1.1rem', fontWeight: 'bold', color: '#7B3F00', marginBottom: 16, marginTop: 0 }}>
                        ◆ Pickup & Delivery Policy ◆
                    </h2>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                        <div style={{ background: '#fff', borderRadius: 10, padding: '1rem', border: '1px solid #FDE68A' }}>
                            <p style={{ fontWeight: 'bold', color: '#3B1E08', margin: '0 0 8px', fontSize: '0.95rem' }}>📍 Pickup <span style={{ fontWeight: 'normal', fontSize: '0.78rem', color: '#B45309' }}>(Preferred)</span></p>
                            {['Pickup only from home', 'Zero extra charges', '100% advance payment', 'UPI / GPay / PhonePe'].map(t => (
                                <p key={t} style={{ margin: '4px 0', fontSize: '0.82rem', color: '#4B2800' }}>✓ {t}</p>
                            ))}
                        </div>
                        <div style={{ background: '#fff', borderRadius: 10, padding: '1rem', border: '1px solid #FDE68A' }}>
                            <p style={{ fontWeight: 'bold', color: '#3B1E08', margin: '0 0 8px', fontSize: '0.95rem' }}>🚚 Delivery <span style={{ fontWeight: 'normal', fontSize: '0.78rem', color: '#B45309' }}>(On Request)</span></p>
                            {['Available on request', 'Charges by distance'].map(t => (
                                <p key={t} style={{ margin: '4px 0', fontSize: '0.82rem', color: '#4B2800' }}>● {t}</p>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Address & Contact */}
                <div style={{ background: '#fff', border: '1px solid #FDE68A', borderRadius: 14, padding: '1.2rem 1.5rem', marginBottom: '1.5rem' }}>
                    <p style={{ margin: '0 0 6px', fontSize: '0.82rem', color: '#92400E', fontWeight: 600, letterSpacing: 1 }}>📌 ADDRESS</p>
                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '0.95rem', color: '#3B1E08' }}>5 Lower Rowden Street,</p>
                    <p style={{ margin: '2px 0', fontSize: '0.88rem', color: '#4B2800', lineHeight: 1.6 }}>
                        Akashdeep Building, A Block, 2nd Floor, Flat No 4,<br />
                        Near JD Birla College, AJC Bose Road,<br />
                        Kolkata – <strong>700020</strong>
                    </p>
                    <p style={{ margin: '12px 0 0', fontSize: '1rem', fontWeight: 'bold', color: '#7B3F00' }}>📞 9975512357</p>
                </div>

                {/* Download again at bottom */}
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <button
                        onClick={handleDownload}
                        style={{ background: 'linear-gradient(135deg, #7B3F00, #5C2D00)', color: '#fff', border: 'none', borderRadius: 50, padding: '12px 36px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 10, boxShadow: '0 4px 12px rgba(123,63,0,0.3)' }}
                    >
                        ⬇ Download Full Menu PDF
                    </button>
                </div>
            </div>

            {/* Footer */}
            <div style={{ background: '#3B1E08', color: '#F5C97E', textAlign: 'center', padding: '1rem', fontSize: '0.85rem', fontStyle: 'italic' }}>
                ✦ Made with love, served with pride ✦
            </div>
        </div>
    );
}
